module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-house-on-a-hill-f1308aa0cf0af4f93a888952631e51fb.svg";